// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectAlertMessage } from '@shared/utils/DirectMessages/DirectMessagesImport';
import { FieldsFactory } from '../Factory/FieldsFactory';
import { MessageProcessorBase } from './MessageProcessorBase';
export class AlertMessageProcessor extends MessageProcessorBase {
    decode(fs) {
        const msg = new DirectAlertMessage();
        msg.AccountId = fs.GetValue(FieldsFactory.FIELD_ACCOUNT_ID);
        msg.UserId = fs.GetValue(FieldsFactory.FIELD_USER_ID);
        msg.InstrumentTradableID = fs.GetValue(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID);
        msg.RouteId = fs.GetValue(FieldsFactory.FIELD_ROUTE_ID);
        msg.AlertId = fs.GetValue(FieldsFactory.FIELD_ALERT_ID);
        msg.AlertType = fs.GetValue(FieldsFactory.FIELD_ALERT_TYPE);
        msg.AlertCondition = fs.GetValue(FieldsFactory.FIELD_ALERT_CONDITION);
        msg.AlertValue = fs.GetValue(FieldsFactory.FIELD_ALERT_VALUE);
        msg.AlertImportance = fs.GetValue(FieldsFactory.FIELD_ALERT_IMPORTANCE);
        msg.Date = fs.GetValue(FieldsFactory.FIELD_DATE);
        msg.AlertAfterExecute = fs.GetValue(FieldsFactory.FIELD_ALERT_AFTER_EXECUTE);
        msg.AlertAction = fs.GetValue(FieldsFactory.FIELD_ALERT_ACTION);
        msg.AlertNotification = fs.GetValue(FieldsFactory.FIELD_ALERT_NOTIFICATION);
        msg.IsAllowOTHTrading = fs.GetValue(FieldsFactory.FIELD_ALLOW_OTH_TRADING);
        msg.Text = fs.GetValue(FieldsFactory.FIELD_TEXT);
        msg.AlertEvent = fs.GetValue(FieldsFactory.FIELD_ALERT_EVENT);
        msg.AlertStatus = fs.GetValue(FieldsFactory.FIELD_ALERT_STATUS);
        const groups = fs.GetGroups(FieldsFactory.ORDER_GROUP_NAME);
        msg.OrderPlaceParametrs = groups.map((g) => this.getOrderPlaceParametersFromGroup(g));
        return [msg];
    }
    getOrderPlaceParametersFromGroup(group) {
        if (isNullOrUndefined(group)) {
            return null;
        }
        const paramsOb = {};
        // paramsOb.order_received_by = group_one.GetValue(FieldsFactory.FIELD_ORDER_RECEIVED_BY);
        paramsOb.stopPrice = group.GetValue(FieldsFactory.FIELD_STOP_PRICE);
        paramsOb.quantity = group.GetValue(FieldsFactory.FIELD_AMOUNT);
        paramsOb.cash = group.GetValue(FieldsFactory.FIELD_CASH_ORDER_QTY);
        paramsOb.productType = group.GetValue(FieldsFactory.FIELD_PRODUCT_TYPE);
        paramsOb.OrderType = group.GetValue(FieldsFactory.FIELD_ORDER_TYPE);
        paramsOb.side = group.GetValue(FieldsFactory.FIELD_OPERATION_TYPE);
        // paramsOb.date = group.GetValue(FieldsFactory.FIELD_DATE);
        paramsOb.limitPrice = group.GetValue(FieldsFactory.FIELD_PRICE);
        // paramsOb.is_by_broker = group.GetValue(FieldsFactory.FIELD_IS_BY_BROKER);
        // paramsOb.boundtoorderid = group.GetValue(FieldsFactory.FIELD_BOUNDTOORDERID);
        paramsOb.tif = group.GetValue(FieldsFactory.FIELD_VALIDITY);
        paramsOb.tradableInstrumentId = group.GetValue(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID);
        // paramsOb.comment = group.GetValue(FieldsFactory.FIELD_COMMENT);
        paramsOb.routeId = group.GetValue(FieldsFactory.FIELD_ROUTE_ID);
        // paramsOb.is_open = group.GetValue(FieldsFactory.FIELD_IS_OPEN);
        paramsOb.accountId = group.GetValue(FieldsFactory.FIELD_ACCOUNT_ID);
        // paramsOb.range = group.GetValue(FieldsFactory.FIELD_RANGE);
        // paramsOb.client_order_id = group.GetValue(FieldsFactory.FIELD_CLIENT_ORDER_ID);
        // paramsOb.client_panel_id = group.GetValue(FieldsFactory.FIELD_CLIENT_PANEL);
        // paramsOb.derivative_position_id = group.GetValue(FieldsFactory.FIELD_DERIVATIVE_POSITION_ID);
        paramsOb.expire_at = group.GetValue(FieldsFactory.FIELD_EXPIRE_AT);
        // paramsOb.poa_user_id = group.GetValue(FieldsFactory.FIELD_POA_USER_ID);
        // paramsOb.order_algorithm = group.GetValue(FieldsFactory.FIELD_ORDER_ALGORITHM);
        paramsOb.disclosedQuantity = group.GetValue(FieldsFactory.FIELD_DISCLOSED_QUANTITY);
        paramsOb.slType = group.GetValue(FieldsFactory.FIELD_SL_PRICE_TYPE);
        paramsOb.tpType = group.GetValue(FieldsFactory.FIELD_TP_PRICE_TYPE);
        paramsOb.slPrice = group.GetValue(FieldsFactory.FIELD_SL_PRICE);
        paramsOb.tpPrice = group.GetValue(FieldsFactory.FIELD_TP_PRICE);
        paramsOb.slLimitPrice = group.GetValue(FieldsFactory.FIELD_SL_LIMIT_PRICE);
        paramsOb.trailingStopOffset = group.GetValue(FieldsFactory.FIELD_TR_OFFSET);
        paramsOb.isAllowOTHTrading = group.GetValue(FieldsFactory.FIELD_ALLOW_OTH_TRADING);
        return paramsOb;
    }
}
